var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appoint-title"},[_c('span',{staticClass:"appoint-title-content"},[_c('span',{staticClass:"appoint-title-required"},[_vm._v(_vm._s(_vm.isCheck?'*':' '))]),_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }